<style lang="less" scoped>
  @import "../vars.less";
  .page-container {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: @background-color;
    box-shadow: 0 0 24px 0 rgba(0,0,0,.1);
  }
  .header,
  .footer,
  .safe-area {
    flex: none;
  }
  .header {
    position: relative;
    top: 0;
    z-index: 2;
  }
  .footer {
    bottom: 0;
    box-sizing: content-box;
  }
  .footer.safe-area {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .body {
    // position: relative;
    overflow: hidden;
    flex: auto;
    // background-image: url("/images/bg3.png");
    // background-size: contain;
    // background-repeat: no-repeat;
    // background-position: bottom center;
  }
  .body-content {
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  .body.spinning {
    overflow: hidden;
  }
  .loading {
    position: absolute;
    left: 0; top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, .75);
  }
  .loading-tip {
    color: @text-color-secondary;
    font-size: 14px;
    padding: @space-normal;
    text-align: center;
  }
  .loading-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<template>
  <div class="page-container" ref="container">
    <div class="header">
      <slot v-if="$slots.header" name="header" />
      <van-nav-bar class="siemens-banner-bg" v-else fixe :border="false"
        :title="title"
        :left-text="$t('返回')"
        left-arrow
        @click-left="() => $back()" />
    </div>
    <div class="body" :style="{ position: !loadingCover ? 'relative' : '' }" :class="{ spinning: loading }">
      <div class="body-content" ref="bodyContent">
        <div ref="bodyInner" :style="{ height: cover ? '100%' : 'auto'}">
          <slot />
          <div class="loading-tip" v-show="infinity">
            <div class="loading-content" v-if="loading">
              <van-loading :style="{ marginRight: '8px' }" color="#009999" size="14px"/>
              <span>{{ $t('正在加载...') }}</span>
            </div>
            <div class="loading-content" v-else>
              <span v-if="!empty && !finished && !loading">{{ $t('上拉加载更多') }}</span>
              <span v-if="!empty && finished && !loading">{{ $t('没有更多了') }}</span>
            </div>
          </div>
          <oh-empty v-show="!loading && empty" />
        </div>
      </div>
      <div v-show="!infinity && loading" class="loading">
        <van-loading color="#009999"/>
      </div>
    </div>
    <div :class="{
      footer: true,
      'safe-area': safeAreaInsetBottom
    }">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { NavBar, Loading } from 'vant'
import BScroll from '@better-scroll/core'
import ObserveDOM from '@better-scroll/observe-dom'
import ScrollBar from '@better-scroll/scroll-bar'
import Pullup from '@better-scroll/pull-up'
import Empty from './Empty'
// import PullDown from '@better-scroll/pull-down'

BScroll.use(ObserveDOM)
BScroll.use(ScrollBar)
BScroll.use(Pullup)
// BScroll.use(PullDown)

export default {
  name: 'page-container',
  components: {
    'van-nav-bar': NavBar,
    'van-loading': Loading,
    'oh-empty': Empty
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    safeAreaInsetBottom: {
      type: Boolean,
      default: true
    },
    infinity: Boolean, // pull up to load more
    // refresh: Boolean, // pull down to refresh
    loading: Boolean,
    finished: Boolean,
    empty: Boolean,
    // if body content has 100% height
    cover: Boolean,
    // if loading cover footer
    loadingCover: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      pollingUp: false
      // pollingDown: false
    }
  },
  watch: {
    loading (v) {
      if (!v && this.pollingUp) {
        this.bs && this.bs.finishPullUp()
        this.pollingUp = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.$refs.bodyContent) return
      this.bs = new BScroll(this.$refs.bodyContent, {
        eventPassthrough: 'horizontal',
        stopPropagation: true,
        observeDOM: true,
        scrollbar: true,
        scrollX: false,
        scrollY: true,
        bounce: {
          top: true,
          bottom: true,
          left: false,
          right: false
        },
        bounceTime: 300,
        swipeTime: 450,
        swipeBounceTime: 300,
        probeType: 3,
        pullUpLoad: {
          threshold: -50
        }
      })

      if (this.infinity) {
        this.bs.on('pullingUp', () => {
          if (this.finished) return
          this.pollingUp = true
          this.$emit('load')
        })
      }
    })
  },
  beforeDestroy () {
    this.bs && this.bs.destroy()
  }
}
</script>
